import { FC } from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import { ArrowRight } from 'svgIcons'
import {
  GSAT_REVIEW_PATHNAME,
  GSAT_REVIEW_SLUG_QUERY,
} from '@app.feature/exam/constants/gsatCommunity'
import { LINKAREER_ACADEMY_COMMUNITY_BASE_URL } from 'utils/config'

const ReviewMoreLink: FC = () => {
  const pathname = `${LINKAREER_ACADEMY_COMMUNITY_BASE_URL}/${GSAT_REVIEW_PATHNAME}`
  const query = GSAT_REVIEW_SLUG_QUERY

  return (
    <Link
      href={{
        pathname,
        query,
      }}
      passHref
    >
      <StyledWrapper>
        실시간 응시후기 더보기 <ArrowRight className="arrow-right" />
      </StyledWrapper>
    </Link>
  )
}

export default ReviewMoreLink

const StyledWrapper = styled.a`
  display: flex;
  align-items: center;
  color: #004eff;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.64px;
  white-space: nowrap;

  .arrow-right {
    width: 12px;
    height: 12px;
    margin-left: 2px;
  }
`
